module.exports = "/images/side-tool-settings-active.svg?a82a61f401c9e3415dfc47f557760d80";